module.exports = __webpack_public_path__ + "assets/img/masterpass-modal.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/masterpass-modal.svg
// module id = 85
// module chunks = 0